__turbopack_context__.v({
  "blog_landing_category": "styles-module-scss-module__vLMKSq__blog_landing_category",
  "blog_landing_view_all": "styles-module-scss-module__vLMKSq__blog_landing_view_all",
  "category_title": "styles-module-scss-module__vLMKSq__category_title",
});
